import {WBIconButton} from '@wandb/ui';
import styled from 'styled-components';

export const Button = styled(WBIconButton)`
  padding: 4px !important;
`;
